import APIService from '@/services/APIService.js'

export default {
  getPreimportacoes () {
    return APIService.apiCall().get('preImportacoesDados/getPreimportacoes')
  },
  getCamposHexa (tipoImportacao) {
    return APIService.apiCall().get('preImportacoesDados/getCamposHexa/'+tipoImportacao)
  },
  getMapeamento (mapeamentoId) {
    return APIService.apiCall().get('preImportacoesDados/getMapeamento/'+mapeamentoId)
  },
  getMapeamentoPreImpo (preImpoId) {
    return APIService.apiCall().get('preImportacoesDados/getMapeamentoPreImpo/'+preImpoId)
  },
  salvarMapeamento (postData) {
    return APIService.apiCall().post('preImportacoesDados/salvarMapeamento', JSON.stringify(postData))
  },
  getCabecalhoComPrimeiraLinhaArquivo (postData) {
    return APIService.apiCall().post('preImportacoesDados/getCabecalhoComPrimeiraLinhaArquivo', JSON.stringify(postData))
  },
  getConflitos (id) {
    return APIService.apiCall().get('preImportacoesDados/getConflitos/'+id)
  },
  processarConflitoImportacao(id, data) {
    return APIService.apiCall().post('preImportacoesDados/processarConflitoImportacao/'+id, JSON.stringify(data))
  },
  downloadLog(id, config = {}) {
    return APIService.apiCall().get(`/preImportacoesDados/baixarLog/${id}`, { responseType: "blob", ...config })
  },
  excluir(id) {
    return APIService.apiCall().delete(`preImportacoesDados/excluir/${id}`)
  },
  salvarPreImportacaoAdm (postData) {
    return APIService.apiCall().post('preImportacoesDados/processar', JSON.stringify(postData))
  },
}
